// extracted by mini-css-extract-plugin
module.exports = {"legal":"cookies_legal__OriRG"};